var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { get, set } from './utils/data';
import { createRequestHooks } from './hooks';
import { pathListKey } from './utils/constant';
var hasCreateProxy = false;
/**
 * 初始化request hooks 只会初始化一次，
 * @param props hooks config
 * @param packageVersion 当前version
 */
export var requestHooks = function (props, packageVersion) {
    try {
        if (!hasCreateProxy) {
            processProxyConfig(props);
            hasCreateProxy = true;
            createRequestHooks(packageVersion || '1');
        }
        else {
            processProxyConfig(props);
        }
    }
    catch (error) {
        // console.log(error);
        throw new Error('init proxt fail, please check security sdk!');
    }
};
var processProxyConfig = function (params) {
    var list = get(pathListKey);
    if (!list || !Array.isArray(list)) {
        set(pathListKey, [params]);
    }
    else {
        set(pathListKey, __spreadArray(__spreadArray([], list, true), [params], false));
    }
};
